import React from 'react'

const LenderModeOfActions = () => {
  return (
    <section id="c-sectionLenderHowItWorks" className="c-sectionWrapper">
		<div className="container">
			<div className="c-sectionHeader">
				<h5 className="c-heading46Bold">Mode of Actions</h5>
				<div className="row justify-content-lg-center">
					<div className="col-lg-7 col-md-12">						
						<p className="c-para22Regular">Understand the easy-to-apply Cycle. Apply with unpaired belief</p>
					</div>
				</div>
			</div>
		</div>
		
			
		<div className="container-fluid">
			<div className="row">
				<div className="c-lenderHiwSteps mt-4 mb-5">
					<img src="./images/lender/mode-action.png" className="mw-100 p-3" alt="" title="" />
				</div>
            {/* <!-- <div className="c-lenderHiwSteps c-lenderHiwStepsRow1">						
                <div className="c-lenderHiwStep c-lenderHiwStep1">
                    <div className="c-lenderHiwStepTitle">Visit the closest showroom</div>
                    <div className="c-lenderHiwStepPara">Lender-branded, Moile-friendly application is pre-filled with existing customer information.</div>
                </div>
                <div className="c-lenderHiwStep c-lenderHiwStep2">
                    <div className="c-lenderHiwStepTitle">Scan the QR Code</div>
                    <div className="c-lenderHiwStepPara">Our risk-based AI model prices customers within your credit parameters resulting.</div>
                </div>					
                <div className="c-lenderHiwStep c-lenderHiwStep3">
                    <div className="c-lenderHiwStepTitle">Fill the Application</div>
                    <div className="c-lenderHiwStepPara">Customer information is verified with many applicants approved automatically.</div>
                </div>
                <div className="c-lenderHiwStep c-lenderHiwStep4">
                    <div className="c-lenderHiwStepTitle">Loan Approved </div>
                    <div className="c-lenderHiwStepPara">We provide an e-signature process with our refinance verification.</div>
                </div>
                <div className="c-lenderHiwStep c-lenderHiwStep5">
                    <div className="c-lenderHiwStepTitle">Electric Vehicle is your own</div>
                    <div className="c-lenderHiwStepPara">Finayo handles title management for both electronic and paper titles creating.</div>
                </div>				
            </div>
            <div className="c-lenderHiwSteps c-lenderHiwStepsRow2">						
                <div className="c-lenderHiwStep c-lenderHiwStep1"></div>
                <div className="c-lenderHiwStep c-lenderHiwStep2">
                    <div className="c-lenderHiwStepTitle">Credit decisioning</div>
                    <div className="c-lenderHiwStepPara">Our risk-based AI model prices customers within your credit parameters resulting.</div>
                </div>					
                <div className="c-lenderHiwStep c-lenderHiwStep3"></div>
                <div className="c-lenderHiwStep c-lenderHiwStep4">
                    <div className="c-lenderHiwStepTitle">Loan closing</div>
                    <div className="c-lenderHiwStepPara">We provide an e-signature process with our refinance verification.</div>
                </div>
                <div className="c-lenderHiwStep c-lenderHiwStep5"></div>						
            </div> --> */}
			</div>
			{/* <!-- <div className="text-center c-mt30">
				<a href="#c-sectionRequestInfoForm" className="c-btnOrangeSolidSharp">Get more info &nbsp;&nbsp; &xrarr;</a>
			</div> --> */}
		</div>
			
	</section>
  )
}

export default LenderModeOfActions